import React from "react"
import Text from "@/components/common/Text"

const Paragraph = ({ color, fontFamily = "strawford", children }) => {
	return (
		<Text className={`typo-${fontFamily}-74`} color={color}>
			{children}
		</Text>
	)
}

export default Paragraph
